// Template definitions for insurance and financial products

// FREE TEMPLATES - Diese 3 sind für alle User verfügbar
export const FREE_TEMPLATE_IDS = ['bu', 'kfz', 'haftpflicht'];

export const TEMPLATES = [
  // Lebensversicherung & Altersvorsorge
  {
    id: 'bu',
    name: 'Berufsunfähigkeitsversicherung',
    category: 'Lebensversicherung & Altersvorsorge',
    description: 'Zielgruppe: Selbstständige, Handwerker, Angestellte 25-50 Jahre. Fokus auf Einkommenssicherung und Existenzschutz bei Berufsunfähigkeit.',
    isFree: true, // Kostenlos verfügbar
    colors: {
      primary: '#2563eb',
      secondary: '#1e40af'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Professioneller deutscher Geschäftsmann mittleren Alters (35-45 Jahre) in modernem, hellem Büro mit Glasfassade. Selbstbewusste, erfolgreiche Körperhaltung, trägt Business-Casual-Kleidung (Hemd ohne Krawatte). Im Hintergrund: modernes Bürogebäude, Skyline einer deutschen Stadt. Warmes, natürliches Tageslicht durch große Fenster. Positive, motivierende Atmosphäre. Hochwertige, professionelle Fotografie im Corporate-Stil. Farben: Blautöne, Weiß, Grau. Bildkomposition: Person im Vordergrund, Unschärfe im Hintergrund für Tiefenwirkung.',
    bulletPoints: [
      'Absicherung Ihres Einkommens bei Berufsunfähigkeit',
      'Finanzieller Schutz für Sie und Ihre Familie',
      'Individuelle Beratung & flexible Vertragsgestaltung'
    ],
    bulletEmoji: '🛡️',
    imageText: 'EINKOMMENS-SCHUTZ',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'rente',
    name: 'Klassische Rentenversicherung',
    category: 'Lebensversicherung & Altersvorsorge',
    description: 'Zielgruppe: 45-65 Jahre, Angestellte & Selbstständige. Fokus auf sicheren Ruhestand, garantierte Zusatzrente, finanzielle Unabhängigkeit im Alter.',
    colors: {
      primary: '#059669',
      secondary: '#047857'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Glückliches deutsches Rentnerpaar (60-70 Jahre) am Strand bei goldenem Sonnenuntergang. Sie sitzen entspannt auf Liegestühlen, genießen gemeinsam den Moment, lächeln zufrieden. Warmes, goldenes Abendlicht. Meer im Hintergrund mit sanften Wellen. Atmosphäre: Entspannung, Lebensfreude, Sorglosigkeit, erfüllter Ruhestand. Natürliche, authentische Darstellung (keine übertriebene Inszenierung). Farben: Gold, Orange, Türkisblau, warme Töne. Hochwertige Lifestyle-Fotografie. Bildkomposition: Paar im Fokus, Strand und Meer schaffen friedliche Kulisse.',
    bulletPoints: [
      'Garantierte lebenslange Rente ab Rentenbeginn',
      'Planbare und sichere Altersvorsorge',
      'Steuerliche Vorteile & staatliche Förderung nutzen'
    ],
    bulletEmoji: '🏖️',
    imageText: 'RENTE MIT PLAN',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'leben',
    name: 'Lebensversicherung',
    category: 'Lebensversicherung & Altersvorsorge',
    description: 'Zielgruppe: Junge Familien 25-45 Jahre mit Kindern, Hauptverdiener. Fokus auf Hinterbliebenenabsicherung, finanzielle Sicherheit der Familie bei Todesfall.',
    colors: {
      primary: '#dc2626',
      secondary: '#991b1b'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Liebevolle deutsche Familie (Eltern Mitte 30, zwei Kinder 5-10 Jahre) im sonnigen Park oder Garten. Eltern und Kinder spielen gemeinsam, lachen herzlich, umarmen sich. Vater und Mutter auf Augenhöhe mit Kindern. Atmosphäre: Geborgenheit, Sicherheit, Familienglück, unbeschwerte Momente. Natürliches Tageslicht, warme Farben. Grüne Wiese, Bäume im Hintergrund. Authentische, emotionale Darstellung (keine gestellte Werbefoto-Ästhetik). Hochwertige Familien-Fotografie. Farben: Grün, warme Hauttöne, helle freundliche Töne. Bildkomposition: Familie im Zentrum, natürliche Umgebung schafft sichere, heimische Atmosphäre.',
    bulletPoints: [
      'Finanzieller Schutz für Ihre Liebsten im Ernstfall',
      'Absicherung von Krediten und laufenden Kosten',
      'Flexible Laufzeiten & anpassbare Versicherungssumme'
    ],
    bulletEmoji: '❤️',
    imageText: 'FAMILIE SICHERN',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'bav',
    name: 'Betriebliche Altersvorsorge (bAV)',
    category: 'Lebensversicherung & Altersvorsorge',
    colors: {
      primary: '#7c3aed',
      secondary: '#5b21b6'
    },
    style: 'modern',
    format: 'instagram_feed',
    prompt: 'Modernes deutsches Unternehmen: Diverse Gruppe von erfolgreichen Mitarbeitern (25-50 Jahre, verschiedene Ethnien) in hellem, modernem Open-Space-Büro mit Glaswänden. Teamwork-Situation: Kollegen arbeiten gemeinsam an einem Projekt, lächeln, diskutieren konstruktiv. Moderne Büroausstattung (höhenverstellbare Schreibtische, ergonomische Stühle, Whiteboards, Laptops). Helles, natürliches Licht durch große Fenster. Atmosphäre: Professionalität, Erfolg, Zusammenarbeit, moderne Arbeitswelt, Mitarbeiterförderung. Hochwertige Corporate-Fotografie. Farben: Lila-Akzente, Weiß, Grau, moderne Business-Farben. Bildkomposition: Team im Fokus, modernes Büro unterstreicht progressive Unternehmenskultur.',
    bulletPoints: [
      'Arbeitgeber-Zuschuss nutzen',
      'Steuer- und Sozialabgaben sparen',
      'Extra-Rente aufbauen'
    ],
    bulletEmoji: '💼',
    imageText: 'BAV-VORTEIL',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'kind',
    name: 'Kindersparvertrag',
    category: 'Lebensversicherung & Altersvorsorge',
    colors: {
      primary: '#f59e0b',
      secondary: '#d97706'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Fröhliches deutsches Kind (6-10 Jahre) mit klassischem Keramik-Sparschwein in modernem, hellem Kinderzimmer. Kind lächelt stolz, wirft Münze in Sparschwein ein. Elternteil im Hintergrund beobachtet liebevoll die Szene. Helle, freundliche Farben: Pastelltöne, Gelb, Hellblau. Natürliches Tageslicht durch Fenster. Spielzeug und Bücher im Hintergrund deuten auf geborgenes Zuhause hin. Atmosphäre: Zukunftsoptimismus, Lernen, Verantwortung, Eltern-Kind-Bindung, finanzielle Bildung. Hochwertige Familien-Lifestyle-Fotografie. Bildkomposition: Kind im Fokus, warme heimische Umgebung vermittelt Sicherheit und Vorsorge.',
    bulletPoints: [
      'Früh anfangen lohnt sich',
      'Finanzielle Freiheit für Ihr Kind',
      'Flexible Einzahlungen möglich'
    ],
    bulletEmoji: '🎓',
    imageText: 'KINDER-ZUKUNFT',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },

  // Krankenversicherung
  {
    id: 'pkv',
    name: 'Krankenvollversicherung (PKV)',
    category: 'Krankenversicherung',
    colors: {
      primary: '#0891b2',
      secondary: '#0e7490'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Modernes deutsches Krankenhaus: Freundlicher, kompetenter Arzt (40-55 Jahre, weißer Kittel) im Gespräch mit Patient in heller, sauberer Praxis. Arzt hört aufmerksam zu, zeigt Empathie, erklärt etwas auf Tablet. Modernes medizinisches Equipment im Hintergrund. Helles, steriles aber dennoch warmes Licht. Atmosphäre: Vertrauen, Professionalität, beste medizinische Versorgung, Fürsorge, Kompetenz. Hochwertige medizinische Fotografie. Farben: Weiß, Hellblau, saubere klinische Töne mit menschlicher Wärme. Bildkomposition: Arzt-Patient-Interaktion im Fokus, moderne Praxisausstattung unterstreicht Qualität.',
    bulletPoints: [
      'Chefarztbehandlung',
      'Keine Wartezeiten',
      'Weltweiter Schutz'
    ],
    bulletEmoji: '⚕️',
    imageText: 'PRIVAT-STATUS',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'zahn',
    name: 'Zahnzusatzversicherung',
    category: 'Krankenversicherung',
    colors: {
      primary: '#06b6d4',
      secondary: '#0891b2'
    },
    style: 'modern',
    format: 'instagram_feed',
    prompt: 'Attraktive Person (25-40 Jahre) mit strahlendem, gesundem Lächeln in modernem deutschen Zahnarztpraxis. Zeigt perfekte, weiße Zähne beim natürlichen Lachen. Freundliche Zahnärztin im Hintergrund (unscharfpraxis). Helles, professionelles Licht. Moderne zahnmedizinische Ausstattung sichtbar. Atmosphäre: Selbstbewusstsein, Gesundheit, Lebensfreude, professionelle Zahnpflege, Schönheit. Hochwertige Dental-Lifestyle-Fotografie. Farben: Weiß, Hellblau, Türkis, saubere helle Töne. Bildkomposition: Lächelndes Gesicht in Nahaufnahme, Fokus auf perfektes Lächeln und gesunde Zähne.',
    bulletPoints: [
      'Bis zu 100% Kostenübernahme',
      'Hochwertiger Zahnersatz',
      'Prophylaxe inklusive'
    ],
    bulletEmoji: '😁',
    imageText: 'ZAHN-SCHUTZ 100%',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'heilpraktiker',
    name: 'Heilpraktikerversicherung',
    category: 'Krankenversicherung',
    colors: {
      primary: '#84cc16',
      secondary: '#65a30d'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Ruhige, natürliche Wellness-Szene: Entspannte Person (30-50 Jahre) bei Naturheilkunde-Behandlung. Heilpraktikerin bereitet natürliche Kräuter und ätherische Öle vor. Warmes, weiches Licht. Holzelemente, Pflanzen, Naturmaterialien im Raum. Getrocknete Heilkräuter, Aromatherapie-Flaschen, Naturprodukte sichtbar. Atmosphäre: Ganzheitliche Gesundheit, Entspannung, natürliche Heilung, Harmonie, Wohlbefinden, alternative Medizin. Hochwertige Wellness-Fotografie. Farben: Erdtöne, Grün, Braun, natürliche warme Töne. Bildkomposition: Friedliche Behandlungsszene, Naturelemente unterstreichen ganzheitlichen Ansatz.',
    bulletPoints: [
      'Alternative Heilmethoden',
      'Naturheilkunde Erstattung',
      'Ganzheitliche Gesundheit'
    ],
    bulletEmoji: '🌿',
    imageText: 'NATÜRLICH GESUND',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'brille',
    name: 'Brillenversicherung',
    category: 'Krankenversicherung',
    colors: {
      primary: '#8b5cf6',
      secondary: '#6d28d9'
    },
    style: 'modern',
    format: 'instagram_feed',
    prompt: 'Stylischer deutscher Optiker-Laden: Attraktive Person (25-45 Jahre) probiert moderne Designer-Brille vor elegantem Spiegel an. Regal mit vielfältigen Brillenmodellen im Hintergrund. Kompetente Optikerin berät im Hintergrund. Modernes, helles Ladendesign. Warmes Licht betont die Brillen. Atmosphäre: Stil, Mode, Sehqualität, Selbstbewusstsein, professionelle Beratung. Hochwertige Lifestyle- und Fashion-Fotografie. Farben: Lila-Akzente, Schwarz, Silber, moderne elegante Töne. Bildkomposition: Person mit Brille im Fokus, moderne Brillenauswahl unterstreicht Style und Qualität.',
    bulletPoints: [
      'Neue Brille alle 2 Jahre',
      'Markengläser inklusive',
      'Sehhilfen ohne Zuzahlung'
    ],
    bulletEmoji: '👓',
    imageText: 'VOLLE SICHT',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'beamte',
    name: 'Beamtentarife / Freie Heilfürsorge',
    category: 'Krankenversicherung',
    colors: {
      primary: '#1e40af',
      secondary: '#1e3a8a'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Seriöser deutscher Beamter (40-60 Jahre) in Uniform oder Business-Kleidung vor repräsentativem deutschen Rathaus oder Verwaltungsgebäude. Selbstbewusste, vertrauenswürdige Ausstrahlung. Klare Architektur, Säulen, Staatswappen im Hintergrund. Natürliches Tageslicht. Atmosphäre: Stabilität, Sicherheit, öffentlicher Dienst, Verantwortung, Vertrauenswürdigkeit, deutsche Verwaltungstradition. Hochwertige Corporate-Fotografie. Farben: Blau, Grau, Weiß, seriöse professionelle Töne. Bildkomposition: Beamter im Vordergrund, imposantes Verwaltungsgebäude symbolisiert staatliche Sicherheit.',
    bulletPoints: [
      'Speziell für Beamte',
      'Ergänzung zur Beihilfe',
      'Optimale Absicherung'
    ],
    bulletEmoji: '🏛️',
    imageText: 'BEAMTEN-PLUS',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },

  // Sachversicherungen
  {
    id: 'kfz',
    name: 'Kfz-Versicherung',
    category: 'Sachversicherungen',
    isFree: true, // Kostenlos verfügbar
    colors: {
      primary: '#ef4444',
      secondary: '#dc2626'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Modernes deutsches Auto (aktuelles Mittelklasse-Modell, silber oder dunkelblau) auf schöner, kurviger Landstraße durch grüne Hügellandschaft. Auto in dynamischer Fahrt, leichte Bewegungsunschärfe im Hintergrund. Glänzende, perfekt gepflegte Karosserie. Sonnenlicht reflektiert auf Lack. Deutscher Wald oder Felder im Hintergrund. Atmosphäre: Sicherheit, Mobilität, Freiheit, Fahrspaß, Zuverlässigkeit, Schutz. Hochwertige Automotive-Fotografie. Farben: Blau/Silber des Autos, Grün der Natur, klarer Himmel. Bildkomposition: Auto im Fokus, schöne Landschaft unterstreicht Fahrerlebnis.',
    bulletPoints: [
      'Umfassender Schutz',
      'Schnelle Schadensregulierung',
      'Top Preis-Leistung'
    ],
    bulletEmoji: '🚗',
    imageText: 'DEIN AUTO-SCHUTZ',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'haftpflicht',
    name: 'Haftpflichtversicherung',
    category: 'Sachversicherungen',
    isFree: true, // Kostenlos verfügbar
    colors: {
      primary: '#10b981',
      secondary: '#059669'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Schützende Szene: Zwei Hände (eine Hand eines Erwachsenen, eine Hand eines Kindes) halten sich gegenseitig vor unscharfem, warmem Hintergrund. Oder: Offene Hände formen schützendes Dach über Miniatur-Haus und Familie-Figuren. Weiches, warmes goldenes Licht. Atmosphäre: Schutz, Sicherheit, Verantwortung, Fürsorge, Vertrauen, Geborgenheit. Hochwertige symbolische Lifestyle-Fotografie. Farben: Warme Hauttöne, Gold, sanfte Hintergrundfarben. Bildkomposition: Hände im Fokus, Geste vermittelt universellen Schutz und Sicherheit.',
    bulletPoints: [
      'Schutz vor Schadenersatz',
      'Weltweiter Versicherungsschutz',
      'Bis zu 50 Mio. € Deckung'
    ],
    bulletEmoji: '🛡️',
    imageText: 'SCHUTZ IM ALLTAG',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'hausrat',
    name: 'Hausrat/Gebäude',
    category: 'Sachversicherungen',
    colors: {
      primary: '#f97316',
      secondary: '#ea580c'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Gemütliches, modernes deutsches Wohnzimmer: Einladende Couch, stilvolle Möbel, warmes Licht durch Fenster. Moderne Einrichtung (Scandinavian Style): helle Holzmöbel, Pflanzen, Bücherregal, Familienfotos an Wand. Niemand im Bild - Fokus auf schönes, gepflegtes Zuhause. Nachmittagslicht schafft warme, gemütliche Atmosphäre. Atmosphäre: Geborgenheit, Sicherheit, Zuhause-Gefühl, Wertigkeit, Schutz des Eigentums. Hochwertige Interior-Fotografie. Farben: Warme Holztöne, Beige, Weiß, Grün (Pflanzen), gemütliche Wohntöne. Bildkomposition: Wohnraum zeigt Wert des Zuhauses und Notwendigkeit des Schutzes.',
    bulletPoints: [
      'Ihr Hab und Gut geschützt',
      'Neuwerterstattung',
      'Elementarschäden inklusive'
    ],
    bulletEmoji: '🏠',
    imageText: 'DEIN HEIM SICHER',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'unfall',
    name: 'Unfallversicherung',
    category: 'Sachversicherungen',
    colors: {
      primary: '#ec4899',
      secondary: '#db2777'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Sportliche, aktive Person (25-45 Jahre) beim Outdoor-Sport: Joggen, Radfahren oder Wandern in schöner deutscher Naturlandschaft. Person trägt Sportkleidung und Helm/Schutzausrüstung. Dynamische Bewegung, fit und gesund. Sonniges Wetter, grüne Umgebung (Wald oder Berge). Atmosphäre: Aktivität, Gesundheit, Lebensfreude, Bewegung, Sicherheitsbewusstsein, aktiver Lebensstil. Hochwertige Sport- und Lifestyle-Fotografie. Farben: Kräftige Sportfarben, Grün der Natur, blauer Himmel. Bildkomposition: Aktive Person in Bewegung, Natur unterstreicht gesunden, aktiven Lebensstil.',
    bulletPoints: [
      '24h Schutz weltweit',
      'Hohe Invaliditätsleistung',
      'Bergungskosten inklusive'
    ],
    bulletEmoji: '⛑️',
    imageText: 'UNFALL-SCHUTZ',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'privathaft',
    name: 'Privathaftpflicht',
    category: 'Sachversicherungen',
    colors: {
      primary: '#06b6d4',
      secondary: '#0891b2'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Deutsche Familie (Eltern Mitte 30, zwei Kinder 4-10 Jahre) zu Hause in gemütlichem Wohnzimmer. Familie spielt gemeinsam Brettspiel am Tisch, alle lachen und haben Spaß. Oder: Familie kocht zusammen in moderner Küche. Warmes, natürliches Licht durch Fenster. Moderne, aber gemütliche Einrichtung. Atmosphäre: Alltags-Harmonie, Zusammenhalt, Sicherheit zuhause, Familienglück, Normalität, Geborgenheit. Hochwertige Familien-Lifestyle-Fotografie. Farben: Warme Wohntöne, helle freundliche Farben, natürliches Licht. Bildkomposition: Familie im Mittelpunkt, heimische Umgebung vermittelt Alltags-Sicherheit.',
    bulletPoints: [
      'Unverzichtbar im Alltag',
      'Familienversicherung möglich',
      'Mietsachschäden versichert'
    ],
    bulletEmoji: '👨‍👩‍👧‍👦',
    imageText: 'PFLEGE-VORSORGE',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'hunde',
    name: 'Hundeversicherung',
    category: 'Sachversicherungen',
    colors: {
      primary: '#f59e0b',
      secondary: '#d97706'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Glücklicher Hund (Golden Retriever oder Labrador) mit liebevollem Besitzer in schönem Park oder Garten. Hund ist gesund, aktiv und fröhlich. Besitzer streichelt den Hund liebevoll. Warmes, natürliches Tageslicht. Grüne Wiese, Bäume im Hintergrund. Atmosphäre: Verbundenheit, Fürsorge, Verantwortung, Lebensfreude. Hochwertige Tierfotografie. Farben: Warme Braun- und Goldtöne, Grün. Bildkomposition: Hund und Besitzer im Fokus, harmonische Beziehung zwischen Mensch und Tier.',
    bulletPoints: [
      'OP-Kostenabsicherung bis 100%',
      'Haftpflicht für Schäden durch Ihren Hund',
      'Tierklinik-Behandlungen versichert'
    ],
    bulletEmoji: '🐕',
    imageText: 'HUNDE-SCHUTZ',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'katze',
    name: 'Katzenversicherung',
    category: 'Sachversicherungen',
    colors: {
      primary: '#a855f7',
      secondary: '#9333ea'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Niedliche, gesunde Katze (Hauskatze) wird von liebevollem Besitzer zu Hause gestreichelt. Katze sieht zufrieden und entspannt aus, schnurrt. Gemütliches, modernes Wohnzimmer mit Fenster und Tageslicht. Atmosphäre: Geborgenheit, Fürsorge, häusliches Glück. Warme, weiche Beleuchtung. Farben: Sanfte Pastelltöne, Grau, Weiß, warme Brauntöne. Hochwertige Haustier-Fotografie. Bildkomposition: Katze und Besitzer in harmonischer, zärtlicher Interaktion.',
    bulletPoints: [
      'Tierarztkosten bis zu 100% erstattet',
      'Operationen & Behandlungen abgesichert',
      'Freie Tierarztwahl deutschlandweit'
    ],
    bulletEmoji: '🐱',
    imageText: 'FÜR DEINE KATZE.',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },

  // Rechtsschutz
  {
    id: 'rechts_privat',
    name: 'Rechtsschutz Privat',
    category: 'Rechtsschutz',
    colors: {
      primary: '#6366f1',
      secondary: '#4f46e5'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Moderne deutsche Anwaltskanzlei: Seriöser Rechtsanwalt (40-60 Jahre) in elegantem Büro mit Bücherregalen voller Gesetzbücher. Justitia-Statue auf Schreibtisch. Anwalt berät Mandanten im Hintergrund oder arbeitet konzentriert an Dokumenten. Dunkles Holz, Leder, professionelle Atmosphäre. Warmes Licht durch Schreibtischlampe. Atmosphäre: Rechtssicherheit, Kompetenz, Vertrauen, Professionalität, Schutz, Gerechtigkeit. Hochwertige Business-Fotografie. Farben: Dunkelbraun, Gold-Akzente, seriöse professionelle Töne. Bildkomposition: Anwalt oder Justitia im Fokus, Bücher symbolisieren rechtliches Fachwissen.',
    bulletPoints: [
      'Rechtssicherheit im Alltag',
      'Freie Anwaltswahl',
      'Keine Selbstbeteiligung'
    ],
    bulletEmoji: '⚖️',
    imageText: 'DEIN RECHT.',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'rechts_gewerbe',
    name: 'Rechtsschutz Gewerblich',
    category: 'Rechtsschutz',
    colors: {
      primary: '#3b82f6',
      secondary: '#2563eb'
    },
    style: 'modern',
    format: 'instagram_feed',
    prompt: 'Erfolgreicher deutscher Geschäftsführer/Unternehmer (35-55 Jahre) in modernem Eckbüro mit Glaswänden und Stadtblick. Unterschreibt wichtige Verträge oder bespricht Dokumente. Business-Anzug, selbstbewusst. Modernes Büro mit großem Schreibtisch, Computer, Aktenordner. Tageslicht durch Panoramafenster. Atmosphäre: Geschäftlicher Erfolg, Professionalität, unternehmerische Sicherheit, Rechtssicherheit im Business. Hochwertige Corporate-Fotografie. Farben: Blau, Grau, Schwarz, professionelle Business-Töne. Bildkomposition: Unternehmer im Fokus, Büroumgebung zeigt Geschäftswelt.',
    bulletPoints: [
      'Schutz für Ihr Unternehmen',
      'Vertrags- und Steuerrecht',
      'Sofortige Rechtshilfe'
    ],
    bulletEmoji: '🏢',
    imageText: 'FIRMA GESICHERT',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },

  // Finanzen & Vermögensaufbau
  {
    id: 'gold',
    name: 'Goldsparpläne',
    category: 'Finanzen & Vermögensaufbau',
    colors: {
      primary: '#f59e0b',
      secondary: '#d97706'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Hochwertige Nahaufnahme von glänzenden Goldbarren (1oz, geprägt) und Goldmünzen (Krügerrand, Maple Leaf) auf dunkler, edler Oberfläche (schwarzes Samt oder Holz). Dramatisches Licht betont Gold-Glanz und Reinheit. Einzelne Münzen im Fokus, gestapelte Barren im Hintergrund. Atmosphäre: Wertbeständigkeit, Sicherheit, Vermögensaufbau, Krisenabsicherung, Luxus, Solidität. Hochwertige Produkt-Fotografie. Farben: Sattes Gold, dunkle elegante Hintergründe, warme Reflexionen. Bildkomposition: Gold im Fokus, edles Material vermittelt Wert und Beständigkeit.',
    bulletPoints: [
      'Krisensicheres Investment',
      'Ab 25€ monatlich starten',
      'Physisches Gold erwerben'
    ],
    bulletEmoji: '🪙',
    imageText: 'ECHTES GOLD',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'immo_finanz',
    name: 'Immobilienfinanzierung',
    category: 'Finanzen & Vermögensaufbau',
    colors: {
      primary: '#14b8a6',
      secondary: '#0d9488'
    },
    style: 'realistic',
    format: 'instagram_feed',
    prompt: 'Glückliche deutsche Familie (Eltern Ende 20/Anfang 30, kleines Kind) steht stolz vor ihrem neuen modernen Einfamilienhaus mit Garten. Halten gemeinsam großen goldenen Hausschlüssel in die Kamera. Schönes, neues Haus im Hintergrund: moderne Architektur, große Fenster, gepflegter Vorgarten. Sonniges Wetter. Atmosphäre: Traum erfüllt, Stolz, Eigenheim, Zukunftssicherheit, Familien-Glück, neue Lebensphase. Hochwertige Immobilien-Lifestyle-Fotografie. Farben: Warme Farben, freundliche Haustöne, Grün (Garten), blauer Himmel. Bildkomposition: Familie mit Schlüssel im Vordergrund, Traumhaus im Hintergrund symbolisiert erfüllten Wohntraum.',
    bulletPoints: [
      'Günstige Zinsen sichern',
      'Individuelle Beratung',
      'Bis zu 100% Finanzierung'
    ],
    bulletEmoji: '🏡',
    imageText: 'ENDLICH EIGENTUM',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  },
  {
    id: 'immo_kapital',
    name: 'Immobilien als Kapitalanlage',
    category: 'Finanzen & Vermögensaufbau',
    colors: {
      primary: '#8b5cf6',
      secondary: '#7c3aed'
    },
    style: 'modern',
    format: 'instagram_feed',
    prompt: 'Moderner deutscher Wohnungs-Komplex oder Mehrfamilienhaus: Architektonisch ansprechendes Gebäude mit mehreren Stockwerken, großen Balkonen, moderner Fassade. Perfekt gepflegte Anlage. Oder: Geschäftsmann/Investor (40-60 Jahre) betrachtet Immobilien-Exposé mit Rendite-Grafiken vor Gebäude. Professionelles Tageslicht. Atmosphäre: Investment, Vermögensaufbau, Rendite, Kapitalanlage, finanzielle Intelligenz, Wertsteigerung. Hochwertige Immobilien- und Business-Fotografie. Farben: Lila/Violett-Akzente, Grau, moderne elegante Töne. Bildkomposition: Immobilie im Fokus, moderne Architektur symbolisiert wertvolles Investment.',
    bulletPoints: [
      'Stabile Renditen erzielen',
      'Steuervorteile nutzen',
      'Vermögensaufbau mit Substanz'
    ],
    bulletEmoji: '📈',
    imageText: 'SMART ANLEGEN',
    imageTextPosition: 'top',
    logoPosition: 'bottom-right'
  }
];

// Group templates by category
export const TEMPLATE_CATEGORIES = [
  'Lebensversicherung & Altersvorsorge',
  'Krankenversicherung',
  'Sachversicherungen',
  'Rechtsschutz',
  'Finanzen & Vermögensaufbau'
];

export const getTemplatesByCategory = (category) => {
  return TEMPLATES.filter(t => t.category === category);
};

export const getTemplateById = (id) => {
  return TEMPLATES.find(t => t.id === id);
};
